export type ActiveModalName =
  | "device"
  | "release"
  | "release-delete"
  | "release-download"
  | "release-make-active"
  | "release-send-production"
  | undefined;

export enum ActiveModalNameEnum {
  Device = "device",
  Release = "release",
  ReleaseDelete = "release-delete",
  ReleaseDownload = "release-download",
  ReleaseMakeActive = "release-make-active",
  ReleaseSendToProduction = "release-send-production",
}
export interface ActiveControlPanelModalState {
  name: ActiveModalName;
  ids?: string[];
}

const BrandSoftwareTypes = ["krosskast", "assistant", "player"] as const;

const BrandSoftwareTypeLabels = [
  "KrossKast App",
  "KrossKast Assistant App",
  "KrossKast OS",
] as const;

const BrandSoftwareTypeCommands = [
  "restart_kk_app",
  "restart_assistant_app",
  "restart_player",
  "update_assistant_app",
  "update_kk_app",
  "update_player",
  "update_kk_app_meta",
  "update_assistant_app_meta",
  "update_kk_music_schedule",
  "report_kk_music_schedule",
] as const;

export type BrandSoftwareType = (typeof BrandSoftwareTypes)[number];

type BrandSoftwareTypeLabel = (typeof BrandSoftwareTypeLabels)[number];

export type BrandSoftwareTypeCommand =
  (typeof BrandSoftwareTypeCommands)[number];

export interface BrandSoftwareTypeOption {
  value: BrandSoftwareType;
  label: BrandSoftwareTypeLabel;
}

export interface BrandSoftwareCommandOption {
  command: BrandSoftwareTypeCommand;
  type: BrandSoftwareType;
}

const releaseEnvironmentTypes = ["staging", "production"] as const;
const releaseEnvironmentTypeLabels = ["Staging", "Production"] as const;

export type ReleaseEnvironmentType = (typeof releaseEnvironmentTypes)[number];

type ReleaseEnvironmentTypeLabel =
  (typeof releaseEnvironmentTypeLabels)[number];

export interface ReleaseEnvironmentTypeOption {
  value: ReleaseEnvironmentType;
  label: ReleaseEnvironmentTypeLabel;
}
